import axios from 'axios';

const MAX_LOCAL_EVENTS = 500;
const LOCAL_KEY = 'smartinventory_analytics_events';

function readLocalEvents() {
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeLocalEvents(events) {
  try {
    localStorage.setItem(LOCAL_KEY, JSON.stringify(events.slice(-MAX_LOCAL_EVENTS)));
  } catch {
    // Ignore localStorage failures.
  }
}

export async function trackAnalyticsEvent(eventType, metadata = {}) {
  const payload = {
    event_type: eventType,
    occurred_at: new Date().toISOString(),
    metadata,
  };

  try {
    await axios.post('/client-errors', {
      kind: 'analytics.event',
      message: `analytics:${eventType}`,
      metadata: payload,
      occurred_at: payload.occurred_at,
      pathname: window.location.pathname,
      url: window.location.href,
      user_agent: navigator.userAgent,
      environment: process.env.NODE_ENV,
      build_version: process.env.REACT_APP_BUILD_VERSION || null,
    });
    return true;
  } catch {
    const queued = readLocalEvents();
    queued.push(payload);
    writeLocalEvents(queued);
    return false;
  }
}

export async function flushQueuedAnalytics() {
  const queued = readLocalEvents();
  if (!queued.length) return;

  const remaining = [];
  for (const evt of queued) {
    // eslint-disable-next-line no-await-in-loop
    const sent = await trackAnalyticsEvent(evt.event_type, evt.metadata || {});
    if (!sent) {
      remaining.push(evt);
    }
  }
  writeLocalEvents(remaining);
}
